import React, { useEffect } from 'react'

import { useFieldArray, useFormContext } from '@guiker/react-hook-form'

import { AssetFile } from '../../entity'
import { BaseAssetContainer, BaseAssetContainerProps } from './BaseAssetContainer'

export const RHFAssetContainer: React.FC<BaseAssetContainerProps> = ({ name, readOnly, assets, ...props }) => {
  const { control } = useFormContext()
  const { fields, append, remove, move, replace } = useFieldArray({
    control,
    name,
    keyName: 'key' as unknown as 'id',
  })

  const onAddAsset = (asset: AssetFile) => {
    append(asset)
    props.onAddAsset?.(asset)
  }

  const onRemoveAsset = (index: number) => {
    remove(index)
    props.onRemoveAsset?.(index)
  }

  const onMoveAsset = (dragIndex: number, hoverIndex: number) => {
    move(dragIndex, hoverIndex)
    props.onMoveAsset?.(dragIndex, hoverIndex)
  }

  useEffect(() => {
    assets && replace(assets)
  }, [...(assets ?? [])])

  return (
    <BaseAssetContainer
      {...props}
      assets={fields}
      name={name}
      readOnly={readOnly}
      onAddAsset={onAddAsset}
      onMoveAsset={onMoveAsset}
      onRemoveAsset={onRemoveAsset}
    />
  )
}
